export const environment = {
    projectName: 'EMiRLD',
    defaultTheme: 'EMiRLD',
    production: false,
    name: 'demo',
    version: '1.4.0',
    region: 'us-gov-west-1',
    url: 'https://emirld-demo.gembotcloud.com/',
    endpoint: 'https://tofu-emirld-be-project-demo.gembotcloud.com',
    refreshEndpoint: 'uam-saf-project-demo.gembotcloud.com/auth/refreshToken',
  
    sandboxEnabled: false,
    uamUrl: 'https://uam-demo.gembotcloud.com/',
    cookieInfo: {
      domain: '.gembotcloud.com',
    }
};
